import { useAuth0, Auth0ContextInterface } from "@auth0/auth0-react";
import { GetTokenSilentlyOptions } from "@auth0/auth0-spa-js";

export const useSafeAuth0GetAccessToken: () => Pick<Auth0ContextInterface, "getAccessTokenSilently"> = () => {
  const { getAccessTokenSilently } = useAuth0();
  // Return a safe wrapper around getAccessTokenSilently
  const safeGetAccessTokenSilently = async (options?: GetTokenSilentlyOptions) => {
    try {
      return await getAccessTokenSilently(options);
    } catch (error) {
      return options?.detailedResponse ? {} : "";
    }
  };
  return { getAccessTokenSilently: safeGetAccessTokenSilently as Auth0ContextInterface["getAccessTokenSilently"] };
};
